<div id="search-component">
    <label for="search-box">Article Search</label>
    <input #searchBox id="search-box" (input)="search(searchBox.value)" autocomplete="off"/>
  
    <ul class="search-result">
      <li *ngFor="let article of articles$ | async" >
        <a routerLink="/detail/{{article.id}}">
          {{article.name}}
        </a>
      </li>
    </ul>
  </div>